import { Subscription } from 'xstate'

import { RunnerSnapshot } from '@/state/RunnerStateMachine'
// import Pointers from "@/webgl/core/Pointers";
import { TimeEntity } from '@/webgl/runner/entities/Time'
import GameWorld from '@/webgl/runner/GameWorld'
import { ISystem } from '@/webgl/runner/interfaces/ISystem'

export default class InputSystem implements ISystem {
  private world: GameWorld
  private subscription: Subscription | null = null
  private _paused: boolean = false
  private _altMode: boolean = false
  private _inputEnabled: boolean = true
  private _escape: number = 0

  constructor(world: GameWorld) {
    this.world = world
  }

  dispose() {
    this.stop()
  }

  public start() {
    this.subscription = this.world.state.actor.subscribe(this.checkPause)
    document.addEventListener('keydown', this.onKeyDown)
    document.addEventListener('keyup', this.onKeyUp)
    document.addEventListener('wheel', this.onWheel)
    document.addEventListener('web:pause', this.onWebPause)
    document.addEventListener('web:resume', this.onWebResume)
  }

  public stop() {
    document.removeEventListener('keydown', this.onKeyDown)
    document.removeEventListener('keyup', this.onKeyUp)
    document.removeEventListener('wheel', this.onWheel)
    document.removeEventListener('web:pause', this.onWebPause)
    document.removeEventListener('web:resume', this.onWebResume)
    this.subscription?.unsubscribe()
    this.subscription = null
  }

  checkPause = (snapshot: RunnerSnapshot) => {
    if (snapshot.context.game.paused == this._paused) return
    this._paused = snapshot.context.game.paused
    if (this._paused) {
      this.world.events.GamePause.emit()
    } else {
      this.world.events.GameResume.emit()
    }

    this.world.state.setPaused(this._paused)
  }

  onWebPause = () => {
    this.world.events.GamePause.emit()
    this.world.state.actor.send({ type: 'PAUSE' })
  }

  onWebResume = () => {
    this.world.events.GameResume.emit()
    this.world.state.actor.send({ type: 'RESUME' })
    this.world.state.actor.send({ type: 'CLOSE_POPIN' })
  }

  enablePlayerMove(flag: boolean) {
    this._inputEnabled = flag
  }

  onKeyDown = (e: KeyboardEvent) => {
    if (!this._inputEnabled) return

    // Adding a secret code to stop the game when escape is pressed 6 times in a row
    if (e.key === 'Escape') {
      this._escape++
      if (this._escape > 5) {
        this.world.state.actor.send({ type: 'STOP' })
      }
      return
    } else {
      this._escape = 0
    }

    switch (e.key) {
      case 'ArrowLeft':
        this.world.events.PlayerInput.emit({ direction: -1 })
        break
      case 'ArrowRight':
        this.world.events.PlayerInput.emit({ direction: 1 })
        break
      default:
        break
    }

    if (import.meta.env.VITE_RUNNER_USE_DEV_KEYBOARD !== 'true') return

    switch (e.key) {
      case 'ArrowUp':
        if (this._altMode) {
          this.world.settings.minSpeed += 0.2
          this.world.settings.maxSpeed += 0.2
        }
        break
      case 'ArrowDown':
        if (this._altMode) {
          this.world.settings.minSpeed -= 0.1
          this.world.settings.maxSpeed -= 0.1
        }
        break
      case 'Shift':
        this._altMode = true
        break
      case ' ':
        this.world.state.actor.send({ type: 'TOGGLE_PAUSE' })
        break
      default:
        break
    }
  }

  onKeyUp = (e: KeyboardEvent) => {
    switch (e.key) {
      case 'Shift':
        this._altMode = false
        break
    }
  }

  onWheel = (e: WheelEvent) => {
    if (import.meta.env.VITE_RUNNER_USE_DEV_KEYBOARD !== 'true') return

    if (this._altMode) {
      this.world.settings.minSpeed += -e.deltaY * 0.01 // * 0.01;
      this.world.settings.maxSpeed += -e.deltaY * 0.01 //
      console.log('minSpeed : ', this.world.settings.minSpeed, 'maxSpeed : ', this.world.settings.maxSpeed)
    }
  }

  update(time: TimeEntity): void {}
}
